<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2" v-if="!!bill">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-s">
            Como você deseja pagar a mensalidade de {{ bill.month_name }}?
          </div>

          <p class="z-text">
            Escolha uma das opções abaixo como forma de pagamento.
          </p>
        </div>

        <price-card :full-value="parseFloat(bill.bill_value)" :due-date="bill.due_date" />

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-l">
            Escolha a forma de pagamento
          </div>

          <div class="bill-payment-methods-wrapper">
            <action-card
              title="Pix"
              icon="qrcode"
              class="bill-payment-methods__action-card"
              @click="goToPixPaymentMethod()"
              v-if="showPaymentMethod('pix')"
            />

            <action-card
              title="Cartão de crédito"
              icon="credit-card-blank"
              class="bill-payment-methods__action-card"
              @click="goToCreditPaymentMethod()"
              v-if="showPaymentMethod('credit_card')"
            />

            <action-card
              title="Boleto"
              icon="barcode-alt"
              class="bill-payment-methods__action-card"
              @click="goToBoletoPaymentMethod()"
              v-if="showPaymentMethod('boleto')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.bill-payment-methods-wrapper {
  display: flex;
  flex-direction: column;

  @media (min-width: $screen-md-min) {
    flex-direction: row;
  }
}

.bill-payment-methods__action-card {
  flex: 1;

  &:not(:last-child) {
    margin-bottom: var(--space-medium);
  }

  @media (min-width: $screen-md-min) {
    height: 144px;

    &:first-child {
      margin-right: var(--space-medium);
    }
    &:nth-child(2) {
      margin-right: var(--space-medium);
    }
    &:last-child {
      margin-left: var(--space-medium);
    }
  }
}
</style>

<script>
import { mapGetters, mapState } from 'vuex';
import ActionCard from 'components/action-card';
import Breadcrumb from 'components/breadcrumb';
import PriceCard from 'components/price-card';
import DashboardService from 'services/DashboardService';

export default {
  components: {
    ActionCard,
    Breadcrumb,
    PriceCard,
  },
  data() {
    return {
      bill: {},
    };
  },
  computed: {
    ...mapGetters([
      'getBillFromNotPaidBills',
      'permittedPaymentMethods',
    ]),
    ...mapState(['currentBilling']),
    billId() {
      return this.$route.params.billId;
    },
  },
  methods: {
    checkBillAvailability() {
      if (!this.bill) {
        DashboardService.getBill(this.billId).then((bill) => {
          this.bill = bill;
        });
      }
    },
    hasSinglePaymentMethod() {
      return this.permittedPaymentMethods.length === 1;
    },
    checkPaymentMethods() {
      if (this.hasSinglePaymentMethod()) {
        switch (this.permittedPaymentMethods[0]) {
          case 'pix':
            this.routeToPixPage();
            break;
          case 'credit_card':
            this.routeToCreditCardPage();
            break;
          case 'boleto':
            this.routeToBoletoPage();
            break;
          default:
            break;
        }
      }
    },
    showPaymentMethod(paymentMethod) {
      return this.permittedPaymentMethods.includes(paymentMethod);
    },
    goToPixPaymentMethod() {
      this.$tracker.logEvent('[next bills] Clicked "Pagar com Pix"');
      this.routeToPixPage();
    },
    goToCreditPaymentMethod() {
      this.$tracker.logEvent('[next bills] Clicked "Pagar com cartão de crédito"');
      this.routeToCreditCardPage();
    },
    goToBoletoPaymentMethod() {
      this.$tracker.logEvent('[next bills] Clicked "Pagar com boleto"');
      this.routeToBoletoPage();
    },
    routeToPixPage() {
      this.$router.push({ name: 'nb-pix', params: { billId: this.billId } });
    },
    routeToCreditCardPage() {
      this.$router.push({ name: 'nb-credit-card', params: { billId: this.billId } });
    },
    routeToBoletoPage() {
      this.$router.push({ name: 'bill-boleto', params: { billId: this.billId }, query: { from: 'next-bills' } });
    },
  },
  created() {
    this.checkPaymentMethods();
  },
  mounted() {
    this.bill = this.getBillFromNotPaidBills(this.billId);
    this.checkBillAvailability(); // get bill from the server if it's not in vuex
    this.$tracker.logEvent('[next bills] Viewed New Bill Payment Page', { billId: this.billId });
  },
};
</script>
